module.exports = __webpack_public_path__ + "static/media/heart.584535b8.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/css/images/heart.svg
 ** module id = 146
 ** module chunks = 0
 **/